export default "__VITE_ASSET__BfqPxVny__"